<template>
    <div>
        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <!-- <li class="breadcrumb-item"><a href="#">Promos</a></li> -->
                        <li class="breadcrumb-item active" aria-current="page">
                            Promos
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="cmn-section item-category-list pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="section_heading_box">
                            <h1
                                class="heading1 section_heading position-relative text-center mb-0"
                            >
                                <span class="bg_secondary_white px_40"
                                    >Promos</span
                                >
                            </h1>
                            <h3 class="sub_heading1 text-center mt_6 mb-0">
                                Our Best Selling Items
                            </h3>
                        </div>
                    </div>
                    <div class="col-md-12 apparel promodetails">
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-xl-3">
                                <div class="product">
                                    <router-link
                                        :to="{ name: '24hoursTShirts' }"
                                    >
                                        <div
                                            class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                        >
                                            <img
                                                src="/maincss/images/pen.png"
                                                alt=" "
                                                class="img-fluid product_image_main"
                                            />
                                            <div class="offer-badge">
                                                <span
                                                    class="px_20 py_2 bg_secondary_black font_size_18 text_white"
                                                    >-86%</span
                                                >
                                                <div
                                                    class="font_size_20 text_light_grey_2 mt-2"
                                                >
                                                    Coupon Code
                                                </div>
                                            </div>
                                            <div class="absolute-tittle">
                                                <div
                                                    class="font_size_20 text-uppercase text-danger font-weight-bold"
                                                >
                                                    get code
                                                </div>
                                                <div class="font_size_20">
                                                    30% - 50 Off Regular Custom
                                                    <br />
                                                    Classic Soft Crown Caps
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-3">
                                <div class="product">
                                    <router-link
                                        :to="{ name: '24hoursTShirts' }"
                                    >
                                        <div
                                            class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                        >
                                            <img
                                                src="/maincss/images/pen4.png"
                                                alt=" "
                                                class="img-fluid product_image_main"
                                            />
                                            <div class="offer-badge">
                                                <span
                                                    class="px_20 py_2 bg_secondary_black font_size_18 text_white"
                                                    >-86%</span
                                                >
                                                <div
                                                    class="font_size_20 text_light_grey_2 mt-2"
                                                >
                                                    Coupon Code
                                                </div>
                                            </div>
                                            <div class="absolute-tittle">
                                                <div
                                                    class="font_size_20 text-uppercase text-danger font-weight-bold"
                                                >
                                                    get code
                                                </div>
                                                <div class="font_size_20">
                                                    30% - 50 Off Regular Custom
                                                    <br />
                                                    Classic Soft Crown Caps
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-3">
                                <div class="product">
                                    <router-link
                                        :to="{ name: '24hoursTShirts' }"
                                    >
                                        <div
                                            class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                        >
                                            <img
                                                src="/maincss/images/pen3.png"
                                                alt=" "
                                                class="img-fluid product_image_main"
                                            />
                                            <div class="offer-badge">
                                                <span
                                                    class="px_20 py_2 bg_secondary_black font_size_18 text_white"
                                                    >-86%</span
                                                >
                                                <div
                                                    class="font_size_20 text_light_grey_2 mt-2"
                                                >
                                                    Coupon Code
                                                </div>
                                            </div>
                                            <div class="absolute-tittle">
                                                <div
                                                    class="font_size_20 text-uppercase text-danger font-weight-bold"
                                                >
                                                    get code
                                                </div>
                                                <div class="font_size_20">
                                                    30% - 50 Off Regular Custom
                                                    <br />
                                                    Classic Soft Crown Caps
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-3">
                                <div class="product">
                                    <router-link
                                        :to="{ name: '24hoursTShirts' }"
                                    >
                                        <div
                                            class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                        >
                                            <img
                                                src="/maincss/images/pen2.png"
                                                alt=" "
                                                class="img-fluid product_image_main"
                                            />
                                            <div class="offer-badge">
                                                <span
                                                    class="px_20 py_2 bg_secondary_black font_size_18 text_white"
                                                    >-86%</span
                                                >
                                                <div
                                                    class="font_size_20 text_light_grey_2 mt-2"
                                                >
                                                    Coupon Code
                                                </div>
                                            </div>
                                            <div class="absolute-tittle">
                                                <div
                                                    class="font_size_20 text-uppercase text-danger font-weight-bold"
                                                >
                                                    get code
                                                </div>
                                                <div class="font_size_20">
                                                    30% - 50 Off Regular Custom
                                                    <br />
                                                    Classic Soft Crown Caps
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-3">
                                <div class="product">
                                    <router-link
                                        :to="{ name: '24hoursTShirts' }"
                                    >
                                        <div
                                            class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                        >
                                            <img
                                                src="/maincss/images/pen.png"
                                                alt=" "
                                                class="img-fluid product_image_main"
                                            />
                                            <div class="offer-badge">
                                                <span
                                                    class="px_20 py_2 bg_secondary_black font_size_18 text_white"
                                                    >-86%</span
                                                >
                                                <div
                                                    class="font_size_20 text_light_grey_2 mt-2"
                                                >
                                                    Coupon Code
                                                </div>
                                            </div>
                                            <div class="absolute-tittle">
                                                <div
                                                    class="font_size_20 text-uppercase text-danger font-weight-bold"
                                                >
                                                    get code
                                                </div>
                                                <div class="font_size_20">
                                                    30% - 50 Off Regular Custom
                                                    <br />
                                                    Classic Soft Crown Caps
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-3">
                                <div class="product">
                                    <router-link
                                        :to="{ name: '24hoursTShirts' }"
                                    >
                                        <div
                                            class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                        >
                                            <img
                                                src="/maincss/images/pen4.png"
                                                alt=" "
                                                class="img-fluid product_image_main"
                                            />
                                            <div class="offer-badge">
                                                <span
                                                    class="px_20 py_2 bg_secondary_black font_size_18 text_white"
                                                    >-86%</span
                                                >
                                                <div
                                                    class="font_size_20 text_light_grey_2 mt-2"
                                                >
                                                    Coupon Code
                                                </div>
                                            </div>
                                            <div class="absolute-tittle">
                                                <div
                                                    class="font_size_20 text-uppercase text-danger font-weight-bold"
                                                >
                                                    get code
                                                </div>
                                                <div class="font_size_20">
                                                    30% - 50 Off Regular Custom
                                                    <br />
                                                    Classic Soft Crown Caps
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-3">
                                <div class="product">
                                    <router-link
                                        :to="{ name: '24hoursTShirts' }"
                                    >
                                        <div
                                            class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                        >
                                            <img
                                                src="/maincss/images/pen3.png"
                                                alt=" "
                                                class="img-fluid product_image_main"
                                            />
                                            <div class="offer-badge">
                                                <span
                                                    class="px_20 py_2 bg_secondary_black font_size_18 text_white"
                                                    >-86%</span
                                                >
                                                <div
                                                    class="font_size_20 text_light_grey_2 mt-2"
                                                >
                                                    Coupon Code
                                                </div>
                                            </div>
                                            <div class="absolute-tittle">
                                                <div
                                                    class="font_size_20 text-uppercase text-danger font-weight-bold"
                                                >
                                                    get code
                                                </div>
                                                <div class="font_size_20">
                                                    30% - 50 Off Regular Custom
                                                    <br />
                                                    Classic Soft Crown Caps
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-xl-3">
                                <div class="product">
                                    <router-link
                                        :to="{ name: '24hoursTShirts' }"
                                    >
                                        <div
                                            class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                        >
                                            <img
                                                src="/maincss/images/pen2.png"
                                                alt=" "
                                                class="img-fluid product_image_main"
                                            />
                                            <div class="offer-badge">
                                                <span
                                                    class="px_20 py_2 bg_secondary_black font_size_18 text_white"
                                                    >-86%</span
                                                >
                                                <div
                                                    class="font_size_20 text_light_grey_2 mt-2"
                                                >
                                                    Coupon Code
                                                </div>
                                            </div>
                                            <div class="absolute-tittle">
                                                <div
                                                    class="font_size_20 text-uppercase text-danger font-weight-bold"
                                                >
                                                    get code
                                                </div>
                                                <div class="font_size_20">
                                                    30% - 50 Off Regular Custom
                                                    <br />
                                                    Classic Soft Crown Caps
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <nav
                                    aria-label="Page navigation example"
                                    class="d-flex"
                                >
                                    <ul class="pagination ml-auto mb-0">
                                        <li class="page-item previous">
                                            <a class="page-link" href="#"
                                                ><img
                                                    src="/maincss/images/previous_arrow.svg"
                                                    alt=""
                                                    class="mr_10"
                                                />
                                                Previous</a
                                            >
                                        </li>
                                        <li class="page-item active">
                                            <a class="page-link" href="#">1</a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link" href="#">2</a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link" href="#">3</a>
                                        </li>
                                        <li class="page-item next active">
                                            <a class="page-link" href="#"
                                                >Next
                                                <img
                                                    src="/maincss/images/next_arrow.svg"
                                                    alt=""
                                                    class="ml_10"
                                            /></a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "ItemList",
    components: {},
    mounted() {}
};
</script>
